import { Button as ButtonPrimitive } from "@base-ui/react/button"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

/**
 * Variant/token 1:1 dal prototipo approvato (kit.css .btn-*).
 * primary = impegno (Prenota); secondary = azione secondaria (hover → inchiostro, non verde);
 * ghost = link testuale sottolineato, mai bottone pieno.
 */
const buttonVariants = cva(
  "group/button inline-flex shrink-0 items-center justify-center gap-2.5 whitespace-nowrap font-body text-[13px] font-medium uppercase tracking-[0.14em] transition-colors duration-brand-fast outline-none select-none disabled:pointer-events-none disabled:opacity-50 focus-visible:ring-3 focus-visible:ring-ring/50",
  {
    variants: {
      variant: {
        primary: "rounded-sm border border-transparent bg-rosso-pozzo px-6 py-[13px] text-white hover:bg-rosso-pozzo-dk",
        secondary:
          "rounded-sm border border-inchiostro/30 bg-transparent px-6 py-[13px] text-inchiostro hover:border-inchiostro hover:bg-inchiostro hover:text-avorio",
        ghost:
          "gap-0 rounded-none border-0 border-b border-current px-0 py-1 tracking-[0.06em] text-inchiostro hover:text-rosso-pozzo",
      },
      size: {
        default: "",
        lg: "px-8 py-[17px] text-sm",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  }
)

function Button({
  className,
  variant = "primary",
  size = "default",
  ...props
}: ButtonPrimitive.Props & VariantProps<typeof buttonVariants>) {
  return (
    <ButtonPrimitive
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Button, buttonVariants }
